exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tab-btn[data-v-70c9bdef] {\n  padding: 6px 10px;\n  /*background: #14b1af;*/\n  cursor: pointer;\n  margin-bottom: 1rem;\n  outline: none;\n  color: #32363a;\n  height: 41px;\n  width: 110px;\n}\n.required-field-tabs[data-v-70c9bdef] {\n  background: #f1f3f9;\n}\n.required-field-active-tab[data-v-70c9bdef] {\n  color: #01b1af;\n  border-bottom: 1px solid #01b1af;\n}\n", ""]);

// exports
